module.exports = __webpack_public_path__ + "static/media/Geomanist-Ultra.4125e36d.otf";